export default {
  title: '山西省安裝集團股份有限公司-投資者關係',
  home: {
    nav1: '投資者關係',
    nav2: '訊息披露',
    nav3: '企業管治',
    nav4: '股票資訊',
    nav5: '投資者聯絡'
  },
  item1: {
    tit: '歡迎來到山西省安裝集團股份有限公司投資者關係',
    txt: '我們是一家總部位於中國山西省太原市的工程服務商。我們從事專業工業工程、專業配套工程、其他工程及非工程業務。根據弗若斯特沙利文的資料，按2022年的收入計，我們在超過500名山西省專業工業工程承包商中排名第一，並在中國超過10,000名專業工業工程合同承包公司中位列第五。',
    txt1: '山西省專業工業工程承包商2022年收入',
    txt2: '中國專業工業工程合同承包公司2022年收入'
  },
  item2: {
    tit1: '招股文件',
    tit2: '公告通函',
    tit3: '業績報告',
    strDate: '開始日期',
    endDate: '結束日期',
    input: '請輸入關鍵字',
    all: '總計',
    txt: '條數據'
  },
  item3: {
    tit1: '概覽',
    tit2: '治理文件',
    tit3: '管理團隊'
  },
  item4: {
    tit1: '地址',
    tit2: '電話/傳真',
    tit3: '郵編',
    txt: '中國山西省山西轉型綜合改革示範區唐槐產業園新化路8號'
  },
  item5: {
    tit1: '分時K線',
    tit2: '日K線圖',
    tit3: '周K線圖',
    tit4: '月K線圖'
  }
}
